import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ShoppingCartItem } from '@thro-types/leihbar';

import { ContainerState } from './types';

// The initial state of the ShoppingCart container
export const initialState: ContainerState = {
  open: false,
  items: []
};

const shoppingCartSlice = createSlice({
  name: 'shoppingCart',
  initialState,
  reducers: {
    close(state) {
      state.open = false;
    },
    open(state) {
      state.open = true;
    },
    setItems(state, action: PayloadAction<ShoppingCartItem[]>) {
      state.items = action.payload;
    },
    setAvailabilityOfItem(state, action: PayloadAction<{ id: number }>) {
      const { id } = action.payload;
      // Try to update an item
      state.items.forEach(item => {
        // Mark the item unavailable if the productId matches
        if (item.productId === id) {
          item.unavailable = true;
        }

        // Handle nested products if they exist
        item.product?.products?.forEach(product => {
          if (product.id === id) {
            product.unavailable = true;
          }
        });
      });
    }
  }
});

export const { actions: ShoppingCartActions, reducer, name: sliceKey } = shoppingCartSlice;
